<div *ngIf="visible" class="container py-3">
    <p class="footer-text">{{ "eStore " | translate }}&copy; {{ " Copyright "| translate }}  {{ currentYear }}</p>
</div>
